import { render, staticRenderFns } from "./error-overlay.vue?vue&type=template&id=1fc7957a&"
import script from "./error-overlay.vue?vue&type=script&lang=ts&"
export * from "./error-overlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports